import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { TimeSlot } from '../model/time-slot';
import { TimeslotMasterService } from '../services/timeslot-master.service';
import { UserService } from '../../user/service/user.service';
import { UserDetail } from '../../user/model/user-detail';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum'; 
 
@Component({
  selector: 'app-timeslot',
  templateUrl: './timeslot.component.html',
  styleUrls: ['./timeslot.component.css']
})
export class TimeslotComponent implements OnInit {

  slotData : TimeSlot = new TimeSlot(null,'',null);
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  isAdd  : boolean = true;
  selectedObject : TimeSlot;
  timeSlotsData : TimeSlot[];
  Users :  Array<UserDetail> = Array<UserDetail>();
  user:any;
  isSuperAdmin : boolean = false;
  isDoctor : boolean = false; 
  constructor(private _sharedService: SharedService, private _srvTimeSlot : TimeslotMasterService, private _usrService : UserService) { 
    this.isAdd= true;
     _sharedService.yesEmitted$.subscribe(
        text => {
            if(text.Action===DialogAction.DELETE.toString() && text.Page === 'TIMESLOT') {
                this.delete();
            } else {
                this.clearData();
            }
        });
       /* if(this.authService.getUserRole() === Role.SUPERADMIN.toString()) {
          this.isSuperAdmin = true;
       } else if(this.authService.getUserRole() === Role.DOCTOR.toString()) {
         this.isDoctor = true;
       }*/
  }

  getTimeSlotDetail() : void {
    if(this.slotData.DoctorId != undefined && this.slotData.DoctorId !== null) {
      this.listLoading = true;
      this._srvTimeSlot.getTimeSlots(this.slotData.DoctorId).subscribe(
        data=>{
            this.listLoading = false;
            this.timeSlotsData  = data;
        },
        error=>{
           this.listLoading = false;
        }
      );
    } else {
      this.timeSlotsData = [];
    }
   
  } 
  clearData() : void {
     this.slotData.SlotId= null;
        this.slotData.SlotDescription="";
        this.isAdd= true;
  }
  getUsers() : void {
    
    this._usrService.getUsersDetail().subscribe( data=> {
      this.Users = data;
      if(this.Users.length>0) {
       /* if(this.isDoctor) {
          this.slotData.DoctorId = this.user.UserId;
        } else {
          this.slotData.DoctorId = this.Users[0].UserId;
        }*/
        this.slotData.DoctorId = 0;
        this.getTimeSlotDetail();
      }
     
    },
    error=>{
       
    });
  }
  cancelData() : void {
     if(this.isAdd) {
       this.clearData();
     } else {
       this._sharedService.emitDialog(true,"Cancel",ActionMessage.CANCEL.toString(),true, DialogAction.CANCEL.toString(), 'TIMESLOT' );
     }
       
  }
  editTimeSlot(srvEditObject : TimeSlot) : void {
     this.isAdd = false;
     this.slotData = Object.assign(Object.create(srvEditObject), srvEditObject);
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.slotData.DoctorId = 0;
    this.getTimeSlotDetail();
    //this.getUsers();
  }
  saveTimeSlot() : void {
      this.loading = true;
      this._srvTimeSlot.data = this.slotData;
      if(this.isAdd){
        this.addTimeSlot();
      } else {
        this.updateTimeSlot();
      }
  }
  updateTimeSlot() :void {
     
      this._srvTimeSlot.updateTimeSlot().subscribe(data=>{
        this.loading = false;
        this.message = "TimeSlot "+ ActionMessage.UPDATESUCCESS.toString();
        this.clearData();
        this.getTimeSlotDetail();
        this.hideMessage();
      },
      error=>{
          this.loading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
  }
  addTimeSlot() : void {
     
      this._srvTimeSlot.saveTimeSlot().subscribe(data=>{
        this.loading = false;
        this.message = "TimeSlot "+ ActionMessage.SAVESUCCESS.toString();
        this.clearData();
        this.getTimeSlotDetail();
        this.hideMessage();
      },
      error=>{
          this.loading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
  }
  delete() :void {
      this.listLoading = true;
      this._srvTimeSlot.deleteTimeSlot(this.selectedObject).subscribe(data=>{
        this.listLoading = false;
        this.message = "TimeSlot " + ActionMessage.DELETESUCCESS.toString();      
        this.getTimeSlotDetail();
        this.hideMessage();
      },
      error=>{
          this.listLoading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
  }
  hideMessage() : void {
    setTimeout(() => {
      this.message = '';
    }, 1000);
  }
  deleteTimeSlot(org : TimeSlot) :void {
    this.selectedObject = org;
     this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(), 'TIMESLOT'  );
  }
 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/timeslot/timeslot.component.ts